import { Box, Container } from "@mui/material";
import Footer from "../../../components/footer";
import SignupBanner from "../../../components/signup-banner-left";
import PartnerLogoBanner from "../../../components/PartnerLogoBanner";

const PreLoanApplicationLayout = ({ children }) => {
  return (
    <div className="my-account-body">
      <div className="login-wrapper pre-loan-wrapper">
        <SignupBanner />
        <div className="pre-loan-content-wrapper">
          <Box className="pre-loan-logo-container">
            <PartnerLogoBanner />
          </Box>
          <Container maxWidth="sm" className="pre-loan-content-container">
            {children}
          </Container>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PreLoanApplicationLayout;
